import { NOTY_GLOBAL_TYPE, NOTY_FIELD_TYPE } from 'Constants/NotyType';

// sidebar nav links
export default {
  links: [
    {
      menu_title: '',
      children: [
        {
          menu_title: 'sidebar.material.dashboard',
          menu_icon: 'home',
          path: '/admin/dashboard',
        },
        {
          menu_title: 'sidebar.order',
          menu_icon: 'cart',
          path: '/admin/order',
        },
        {
          menu_title: 'internal.notice.title',
          menu_icon: 'notice',
          path: '/admin/internal-notice',
          type: [NOTY_GLOBAL_TYPE.INTERNAL_NOTICE],
        },
        {
          menu_title: 'private.note',
          menu_icon: 'private-note',
          path: '/admin/private-note',
        },
      ],
      bottom_line: true,
    },
    {
      menu_title: 'sidebar.sales.management',
      children: [
        {
          menu_title: 'field.salesNote',
          menu_icon: 'sales-note',
          path: '/admin/field/sales-note',
          type: [NOTY_FIELD_TYPE.SALES_NOTE, NOTY_FIELD_TYPE.ORDER_SUPPORT],
        },
        // {
        //   menu_title: 'dashboard.field.contract',
        //   menu_icon: 'contract',
        //   path: '/admin/field/contract',
        // },
      ],
    },
    {
      menu_title: 'sidebar.material.field',
      children: [
        {
          menu_title: 'dashboard.field.account.book',
          menu_icon: 'account-book',
          path: '/admin/field/account-book',
          type: [NOTY_FIELD_TYPE.LEDGER],
        },
        {
          menu_title: 'dashboard.field.report',
          menu_icon: 'report',
          path: '/admin/field/work-logs',
          type: [NOTY_FIELD_TYPE.WORK_LOG],
        },
        {
          menu_title: 'dashboard.field.chat',
          menu_icon: 'chat',
          path: '/admin/field/comment',
          type: [NOTY_FIELD_TYPE.COMMENT, NOTY_FIELD_TYPE.COMMENT_CLIENT],
        },
        {
          menu_title: 'dashboard.field.file',
          menu_icon: 'file',
          path: '/admin/field/document',
        },
        {
          menu_title: 'title.field.workLog',
          menu_icon: 'log',
          path: '/admin/field/log-detail',
        },
        {
          menu_title: 'sidebar.field.setting',
          menu_icon: 'setting',
          path: '/admin/field/setting',
        },
      ],
    },
    {
      menu_title: 'sidebar.material.management',
      children: [
        {
          menu_title: 'sidebar.material.order',
          menu_icon: 'order',
          path: '/admin/transaction/order/list',
          type: [NOTY_FIELD_TYPE.ORDER_MATERIAL],
        },
        {
          menu_title: 'sidebar.transaction.transactions',
          menu_icon: 'transaction',
          path: '/admin/transaction/transactions/list',
        },
        {
          menu_title: 'sidebar.material.budget',
          menu_icon: 'budget',
          path: '/admin/field/budget',
          type: [NOTY_FIELD_TYPE.BUDGET, NOTY_FIELD_TYPE.BUDGET_REQUEST],
        },
      ],
    },
    {
      menu_title: 'signIn.join.referral.etc',
      children: [
        {
          menu_title: 'sidebar.material.order.calendar',
          menu_icon: 'calendar',
          path: '/admin/calendar',
          type: [NOTY_FIELD_TYPE.SCHEDULE],
        },
        {
          menu_title: 'sidebar.material.staff',
          menu_icon: 'staff',
          path: '/admin/staff/list',
        },
      ],
    },
  ],
  linksVi: [
    {
      menu_title: 'sidebar.material.dashboard',
      menu_icon: 'vi-home',
      path: '/admin/dashboard',
    },
    {
      menu_title: 'field.title.log.simple',
      menu_icon: 'vi-work-logs',
      path: `/admin/field/work-logs`,
      type: [NOTY_FIELD_TYPE.WORK_LOG],
    },
    {
      menu_title: 'field.comment',
      menu_icon: 'vi-comment',
      path: `/admin/field/comment`,
      type: [NOTY_FIELD_TYPE.COMMENT, NOTY_FIELD_TYPE.COMMENT_CLIENT],
    },
    {
      menu_title: 'dashboard.field.account.book',
      menu_icon: 'vi-account-book',
      path: `/admin/field/account-book`,
      type: [NOTY_FIELD_TYPE.LEDGER],
    },
    {
      menu_title: 'field.salesNote',
      menu_icon: 'vi-sales-note',
      path: `/admin/field/sales-note`,
      type: [NOTY_FIELD_TYPE.SALES_NOTE],
    },
    {
      menu_title: 'dashboard.field.file',
      menu_icon: 'vi-file',
      path: `/admin/field/document`,
    },
    {
      menu_title: 'title.setting',
      menu_icon: 'vi-setting',
      path: `/admin/field/setting`,
    },
  ],
};
